<script>
    import axios from 'axios';
    
    export default {
        install(Vue, options) {
            var apiDomain = options.apiDomain;
            var region = options.region;

            Vue.prototype.$eventsService = {
                /*
                * Get events from API using custom query params
                */
                async searchWithParams(params) {
                    if (params) {
                        params.region = options.region;
                    }                    
                    
                    return await axios.get(apiDomain + '/v1/events/search',{ params: params });
                },

                /*
                * Get event details by Id
                */
                async getEventById(eventId) {
                    return await this.searchWithParams({
                        eventcampaignid: eventId
                    });
                }
            }
        }
    }
</script>